module.exports = __webpack_public_path__ + "img/banner2_3.167ffb52.png";